import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NAccountDelete } from './account-delete.interfaces';

/**
 * Resolver to ensure CMS block exists for the Account Delete page
 */
export const accountDeleteResolver: ResolveFn<void> = async () => {
    const iCmsBlockResource = inject(ICmsBlockResource);

    await iCmsBlockResource.retrieve({ bareUrl: NAccountDelete.componentId }, undefined);
};
